// extracted by mini-css-extract-plugin
export var container = "G_b";
export var email = "G_cd";
export var emails = "G_cc";
export var location = "G_cf";
export var number = "G_cb";
export var numbers = "G_b9";